import { CSSObject } from '@emotion/react';

export const TextInputWrapper: CSSObject = {
  border: '1px solid',
  borderColor: 'gray.300',
};
